import { createMuiTheme } from '@material-ui/core/styles'

const createTheme = brandThemeConfig => {
    let theme = createMuiTheme({
        palette: brandThemeConfig.palette,
        typography: {
            fontFamily: 'Roboto',
            useNextVariants: true,
            h1: {
                fontSize: '28px',
                color: '#2A292D',
            },
            h2: {
                fontSize: '26px',
                fontWeight: 400,
                color: '#2A292D',
            },
            h3: {
                fontSize: '24px',
                fontWeight: 400,
                color: '#2A292D',
            },
            h4: {
                fontSize: '20px',
                fontWeight: 500,
                color: '#2A292D',
            },
            h5: { fontSize: '1rem', color: '#2A292D' },
        },
        variables: {
            lightGrey: '#838383',
            lightestGrey: '#E9E9E9',
            lightestGreyAlt: '#f5f5f5',
            darkGrey: '#2A292D',
            fontWeightLight: '300',
            fontWeightRegular: '400',
            fontWeightMedium: '500',
            fontWeightBold: '700',
            green: '#A5B652',
            red: '#C03256',
            logo: brandThemeConfig.logoUrl,
        },
    })

    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    theme.palette.contrastThreshold = 3
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    theme.palette.tonalOffset = 0.2

    // theme component overrides
    theme.overrides = {
        MuiFab: {
            extended: {
                boxShadow: 'none',
            },
        },
        MuiFormControl: {
            root: {
                minWidth: 120,
                width: '100%',
                margin: theme.spacing(1, 0, 1, 0),
            },
        },
        MuiTypography: {
            h1: {
                marginBottom: theme.spacing(1),
                [theme.breakpoints.up('sm')]: {
                    marginBottom: theme.spacing(3),
                },
            },
            h2: {
                marginBottom: theme.spacing(1),
                fontWeight: 'bold',
                [theme.breakpoints.up('sm')]: {
                    marginBottom: theme.spacing(3),
                },
            },
            h3: {
                marginBottom: theme.spacing(1),
                fontWeight: 'bold',
                [theme.breakpoints.up('sm')]: {
                    marginBottom: theme.spacing(2),
                },
            },
            h4: {
                marginBottom: theme.spacing(1),
                fontWeight: 'bold',
            },
            subtitle1: {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(1),
                fontWeight: 'bold',
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: 'white',
                '&$focused': {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                },
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.75)',
                },
                '&:focus': {
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                },
                "& [class*='MuiSelect-select']:focus": {
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                },
            },
        },
        MuiStepper: {
            root: {
                padding: '0',
                [theme.breakpoints.up('sm')]: {
                    padding: theme.spacing(2),
                },
            },
        },
        MuiStepContent: {
            root: {
                maxWidth: '100%',
            },
        },
        MuiStepLabel: {
            label: {
                marginTop: theme.spacing(1) + 'px !important',
                lineHeight: '1',
                [theme.breakpoints.up('sm')]: {
                    marginTop: theme.spacing(2) + 'px !important',
                    lineHeight: '1.4',
                },
            },
        },
        MuiTabs: {
            root: {
                [theme.breakpoints.down('sm')]: {
                    '& .MuiTabs-flexContainer': {
                        flexWrap: 'wrap',
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: 'inherit',
                    },
                },
            },
        },
        MuiTab: {
            root: {
                fontSize: '0.8rem',
                [theme.breakpoints.down('sm')]: {
                    borderBottom: 'none !important',
                    maxWidth: '100%',
                },
                textTransform: 'none',
                width: '100%',
                '& .MuiTab-wrapper': {
                    [theme.breakpoints.down('sm')]: {
                        alignItems: 'flex-start',
                    },
                },
            },
        },
        MuiInput: {
            root: {
                height: '40px',
                [theme.breakpoints.up('sm')]: {
                    height: '50px',
                },
            },
        },
        MuiTextField: {
            root: {
                height: 'auto',
                '& .MuiOutlinedInput-multiline': {
                    backgroundColor: '#FFF',
                },
                '& > .MuiInput-root': {
                    height: 'auto',
                },
            },
        },
        MuiCheckbox: {
            colorSecondary: {
                color: '#2A292D',
                '&$checked': {
                    color: '#2A292D',
                },
            },
        },
        MuiPickersToolbarText: {
            toolbarTxt: {
                marginBottom: 0,
            },
        },
        MuiTableContainer: {
            root: {
                minHeight: '50px',
            },
        },
        MuiTableRow: {
            root: {
                '&:hover': {
                    cursor: 'pointer',
                },
            },
        },
    }

    return theme
}

export default createTheme
